// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3pdO1","largestCol":"styles_largestCol__LCVko","smallestCol":"styles_smallestCol__2mw49"};